function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _excluded = ["file_path", "height", "size_bytes"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./supply'),
  handleRequestSupply = _require.handleRequestSupply;
var _require2 = require('./address'),
  handleRequestAddress = _require2.handleRequestAddress;
var _require3 = require('./utxo'),
  handleRequestUtxo = _require3.handleRequestUtxo;
var _require4 = require('./holders'),
  handleRequestHolders = _require4.handleRequestHolders;
var _require5 = require('./response'),
  requestParams = _require5.requestParams,
  success = _require5.success,
  failure = _require5.failure;
var _require6 = require('../transaction-lookup'),
  lookupTransaction = _require6.lookupTransaction,
  normalizeTransactionSignature = _require6.normalizeTransactionSignature;
function addBlockStatus(obj, block) {
  try {
    if (block.inLongestChain != null) {
      obj.in_longest_chain = Boolean(block.inLongestChain);
    }
  } catch (err) {
    // Keep the serialized value when the wrapper cannot expose this status.
  }
  try {
    if (block.hasGoldenTicket != null) {
      obj.has_golden_ticket = Boolean(block.hasGoldenTicket);
    }
  } catch (err) {
    // Keep the serialized value when the wrapper cannot expose this status.
  }
  return obj;
}
function blockToJson(block) {
  var obj = addBlockStatus(JSON.parse(block.toJson()), block);
  obj.transactions = (block.transactions || []).map(function (tx) {
    var txjson = tx.toJson();
    txjson.msg = tx.returnMessage();
    return txjson;
  });
  return obj;
}
function blockHeaderToJson(block) {
  var obj = addBlockStatus(JSON.parse(block.toJson()), block);
  obj.transactions = [];
  return obj;
}
function handleRequestBlocks(_x, _x2) {
  return _handleRequestBlocks.apply(this, arguments);
}
function _handleRequestBlocks() {
  _handleRequestBlocks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, txmsg) {
    var _params$count, _params$include_offch;
    var params, count, includeOffchain, beforeId, results, id, hashes, i, block, _block, blocks, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          params = requestParams(txmsg);
          count = Math.min(Number((_params$count = params.count) !== null && _params$count !== void 0 ? _params$count : 20), 50);
          includeOffchain = Boolean((_params$include_offch = params.include_offchain) !== null && _params$include_offch !== void 0 ? _params$include_offch : false);
          beforeId = params.before_id != null ? Number(params.before_id) : null;
          if (!(!Number.isFinite(count) || count <= 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, failure('invalid count'));
        case 1:
          if (!(beforeId != null && Number.isFinite(beforeId) && beforeId > 0)) {
            _context.n = 15;
            break;
          }
          results = [];
          id = beforeId - 1;
        case 2:
          if (!(id > 0 && results.length < count)) {
            _context.n = 14;
            break;
          }
          _context.p = 3;
          if (!includeOffchain) {
            _context.n = 9;
            break;
          }
          _context.n = 4;
          return app.core.blockchain.getHashesAtId(BigInt(id));
        case 4:
          hashes = _context.v;
          i = 0;
        case 5:
          if (!(i < hashes.length && results.length < count)) {
            _context.n = 8;
            break;
          }
          _context.n = 6;
          return app.core.blockchain.getBlock(String(hashes[i]), false);
        case 6:
          block = _context.v;
          if (block) {
            results.push(blockHeaderToJson(block));
          }
        case 7:
          i++;
          _context.n = 5;
          break;
        case 8:
          _context.n = 11;
          break;
        case 9:
          _context.n = 10;
          return app.core.blockchain.getBlock(BigInt(id), false);
        case 10:
          _block = _context.v;
          if (_block) {
            results.push(blockHeaderToJson(_block));
          }
        case 11:
          _context.n = 13;
          break;
        case 12:
          _context.p = 12;
          _t = _context.v;
          return _context.a(3, 14);
        case 13:
          id--;
          _context.n = 2;
          break;
        case 14:
          return _context.a(2, success(results));
        case 15:
          _context.n = 16;
          return app.core.blockchain.getBlocks(count, includeOffchain);
        case 16:
          blocks = _context.v;
          return _context.a(2, success(blocks.map(function (block) {
            return blockHeaderToJson(block);
          })));
      }
    }, _callee, null, [[3, 12]]);
  }));
  return _handleRequestBlocks.apply(this, arguments);
}
function handleRequestBlock(_x3, _x4, _x5) {
  return _handleRequestBlock.apply(this, arguments);
} // Number of recent longest-chain blocks sampled for the dashboard's rolling
// statistics (Golden Ticket coverage in particular). This is a rolling window,
// so coverage is an estimate over the most recent blocks rather than the chain.
function _handleRequestBlock() {
  _handleRequestBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, txmsg, mod) {
    var _params$include_trans;
    var params, includeTransactions, identifier, block, stored, obj, _stored$row, file_path, height, size_bytes, metadata, result, _metadata, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          params = requestParams(txmsg);
          includeTransactions = Boolean((_params$include_trans = params.include_transactions) !== null && _params$include_trans !== void 0 ? _params$include_trans : false);
          identifier = null;
          if (!(params.hash !== undefined && params.hash !== null && params.hash !== '')) {
            _context2.n = 1;
            break;
          }
          identifier = String(params.hash);
          _context2.n = 3;
          break;
        case 1:
          if (!(params.block_id !== undefined && params.block_id !== null && params.block_id !== '')) {
            _context2.n = 2;
            break;
          }
          identifier = BigInt(params.block_id);
          _context2.n = 3;
          break;
        case 2:
          return _context2.a(2, failure('hash or block_id required'));
        case 3:
          _context2.p = 3;
          _context2.n = 4;
          return app.core.blockchain.getBlock(identifier, includeTransactions);
        case 4:
          block = _context2.v;
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t2 = _context2.v;
        case 6:
          if (!(!block && mod !== null && mod !== void 0 && mod.chainIndex)) {
            _context2.n = 9;
            break;
          }
          _context2.n = 7;
          return mod.chainIndex.loadStoredBlock(identifier, includeTransactions);
        case 7:
          stored = _context2.v;
          if (!(stored !== null && stored !== void 0 && stored.block)) {
            _context2.n = 8;
            break;
          }
          obj = includeTransactions ? blockToJson(stored.block) : blockHeaderToJson(stored.block);
          obj.in_longest_chain = stored.row.in_longest_chain == null ? null : Boolean(stored.row.in_longest_chain);
          obj.block_size = stored.row.size_bytes;
          obj.tx_count = stored.row.tx_count;
          return _context2.a(2, success(obj));
        case 8:
          if (!(stored !== null && stored !== void 0 && stored.row)) {
            _context2.n = 9;
            break;
          }
          _stored$row = stored.row, file_path = _stored$row.file_path, height = _stored$row.height, size_bytes = _stored$row.size_bytes, metadata = _objectWithoutProperties(_stored$row, _excluded);
          return _context2.a(2, success(_objectSpread(_objectSpread({}, metadata), {}, {
            id: height,
            previous_block_hash: metadata.parent_hash,
            in_longest_chain: metadata.in_longest_chain == null ? null : Boolean(metadata.in_longest_chain),
            block_size: size_bytes,
            transactions: [],
            body_available: false
          })));
        case 9:
          if (block) {
            _context2.n = 10;
            break;
          }
          return _context2.a(2, failure('block not found'));
        case 10:
          result = includeTransactions ? blockToJson(block) : blockHeaderToJson(block);
          if (!(mod !== null && mod !== void 0 && mod.chainIndex)) {
            _context2.n = 14;
            break;
          }
          _context2.p = 11;
          _context2.n = 12;
          return mod.chainIndex.observe(block, block.inLongestChain);
        case 12:
          _metadata = _context2.v;
          result.tx_count = _metadata.tx_count;
          result.block_size = _metadata.size_bytes;
          _context2.n = 14;
          break;
        case 13:
          _context2.p = 13;
          _t3 = _context2.v;
          console.warn('Explorer: block metadata unavailable', _t3.message);
        case 14:
          return _context2.a(2, success(result));
      }
    }, _callee2, null, [[11, 13], [3, 5]]);
  }));
  return _handleRequestBlock.apply(this, arguments);
}
var INFO_BLOCK_WINDOW = 20;
function bigIntToNumber(value) {
  try {
    return value == null ? null : Number(value);
  } catch (err) {
    return null;
  }
}
function bigIntToString(value) {
  try {
    return value == null ? null : value.toString();
  } catch (err) {
    return null;
  }
}

// Returns a summary of the serving node's blockchain for the explorer dashboard.
// Chain-level values (latest/genesis block ids) and per-block consensus values
// (burn fee, difficulty, fees) are read directly from this full node, so they
// are exact for the node answering the request.
function handleRequestInfo(_x6) {
  return _handleRequestInfo.apply(this, arguments);
}
function _handleRequestInfo() {
  _handleRequestInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
    var blocks, genesisBlockId, latest, goldenTicketCount, i, _blocks$i, readBlockNumber, readBlockString, _t4, _t5, _t6;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          blocks = [];
          _context3.p = 1;
          _context3.n = 2;
          return app.core.blockchain.getBlocks(INFO_BLOCK_WINDOW, false);
        case 2:
          blocks = _context3.v;
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t4 = _context3.v;
          blocks = [];
        case 4:
          if (!Array.isArray(blocks)) {
            blocks = [];
          }
          genesisBlockId = null;
          _context3.p = 5;
          _t5 = bigIntToNumber;
          _context3.n = 6;
          return app.core.blockchain.get_genesis_block_id();
        case 6:
          genesisBlockId = _t5(_context3.v);
          _context3.n = 8;
          break;
        case 7:
          _context3.p = 7;
          _t6 = _context3.v;
          genesisBlockId = null;
        case 8:
          latest = blocks.length ? blocks[0] : null;
          goldenTicketCount = 0;
          for (i = 0; i < blocks.length; i++) {
            try {
              if ((_blocks$i = blocks[i]) !== null && _blocks$i !== void 0 && _blocks$i.hasGoldenTicket) {
                goldenTicketCount++;
              }
            } catch (err) {
              // ignore blocks that cannot report golden-ticket state
            }
          }
          readBlockNumber = function readBlockNumber(getter) {
            if (!latest) {
              return null;
            }
            try {
              return bigIntToNumber(latest[getter]);
            } catch (err) {
              return null;
            }
          };
          readBlockString = function readBlockString(getter) {
            if (!latest) {
              return null;
            }
            try {
              return bigIntToString(latest[getter]);
            } catch (err) {
              return null;
            }
          };
          return _context3.a(2, success({
            latest_block_id: readBlockNumber('id'),
            genesis_block_id: genesisBlockId,
            burnfee: readBlockString('burnFee'),
            difficulty: readBlockNumber('difficulty'),
            fees_last_block: readBlockString('totalFees'),
            atr_fees_last_block: readBlockString('totalFeesAtr'),
            golden_ticket_window: blocks.length,
            golden_ticket_count: goldenTicketCount
          }));
      }
    }, _callee3, null, [[5, 7], [1, 3]]);
  }));
  return _handleRequestInfo.apply(this, arguments);
}
function handleRequestTransaction(_x7, _x8) {
  return _handleRequestTransaction.apply(this, arguments);
}
function _handleRequestTransaction() {
  _handleRequestTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, txmsg) {
    var mod,
      params,
      transactionHash,
      found,
      _args4 = arguments,
      _t7;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          mod = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : null;
          params = requestParams(txmsg);
          transactionHash = params.transaction_hash || params.hash || params.signature;
          if (normalizeTransactionSignature(transactionHash)) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2, failure('transaction signature required'));
        case 1:
          _context4.p = 1;
          _context4.n = 2;
          return lookupTransaction(mod, transactionHash);
        case 2:
          found = _context4.v;
          if (found) {
            _context4.n = 3;
            break;
          }
          return _context4.a(2, failure('transaction signature required'));
        case 3:
          return _context4.a(2, success(found));
        case 4:
          _context4.p = 4;
          _t7 = _context4.v;
          return _context4.a(2, failure(_t7.message || 'Transaction lookup failed'));
      }
    }, _callee4, null, [[1, 4]]);
  }));
  return _handleRequestTransaction.apply(this, arguments);
}
function handleExplorerRequest(_x9, _x0) {
  return _handleExplorerRequest.apply(this, arguments);
}
function _handleExplorerRequest() {
  _handleExplorerRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, txmsg) {
    var mod,
      _args5 = arguments,
      _t8,
      _t9,
      _t0,
      _t1;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          mod = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
          if (txmsg !== null && txmsg !== void 0 && txmsg.request) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2, null);
        case 1:
          _t8 = txmsg.request;
          _context5.n = _t8 === 'request chain' ? 2 : _t8 === 'request blocks' ? 6 : _t8 === 'request block' ? 7 : _t8 === 'request info' ? 10 : _t8 === 'request transaction' ? 11 : _t8 === 'request supply' ? 12 : _t8 === 'request address' ? 13 : _t8 === 'request utxo' ? 14 : _t8 === 'request holders' ? 15 : 16;
          break;
        case 2:
          _context5.p = 2;
          if (mod !== null && mod !== void 0 && mod.chainIndex) {
            _context5.n = 3;
            break;
          }
          return _context5.a(2, failure('Chain index unavailable'));
        case 3:
          _t9 = success;
          _context5.n = 4;
          return mod.chainIndex.range(requestParams(txmsg));
        case 4:
          return _context5.a(2, _t9(_context5.v));
        case 5:
          _context5.p = 5;
          _t0 = _context5.v;
          return _context5.a(2, failure(_t0.message || 'Chain request failed'));
        case 6:
          return _context5.a(2, handleRequestBlocks(app, txmsg));
        case 7:
          _context5.p = 7;
          _context5.n = 8;
          return handleRequestBlock(app, txmsg, mod);
        case 8:
          return _context5.a(2, _context5.v);
        case 9:
          _context5.p = 9;
          _t1 = _context5.v;
          return _context5.a(2, failure(_t1.message || 'Block request failed'));
        case 10:
          return _context5.a(2, handleRequestInfo(app));
        case 11:
          return _context5.a(2, handleRequestTransaction(app, txmsg, mod));
        case 12:
          return _context5.a(2, handleRequestSupply(app, mod, txmsg));
        case 13:
          return _context5.a(2, handleRequestAddress(app, mod, txmsg));
        case 14:
          return _context5.a(2, handleRequestUtxo(app, txmsg));
        case 15:
          return _context5.a(2, handleRequestHolders(app, mod, txmsg));
        case 16:
          return _context5.a(2, null);
        case 17:
          return _context5.a(2);
      }
    }, _callee5, null, [[7, 9], [2, 5]]);
  }));
  return _handleExplorerRequest.apply(this, arguments);
}
module.exports = {
  handleExplorerRequest: handleExplorerRequest,
  requestParams: requestParams,
  success: success,
  failure: failure,
  blockToJson: blockToJson,
  blockHeaderToJson: blockHeaderToJson
};